import React from 'react';

import PropTypes from 'prop-types';

import { Badge } from '@/components/ui/badge';
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from '@/components/ui/hover-card';
import { cn } from '@/lib/utils';

import { tagShape } from '../../types';
import { BADGE_COLORS } from './colors';
import Tag from './Tag';
import TagSwatch from './TagSwatch';

const MAX_VISIBLE_TAGS = 6;

const TagList = ({ tags, className = '' }) => {
  if (tags.length === 0) return null;

  const hasOverflow = tags.length > MAX_VISIBLE_TAGS;
  const visibleCount = hasOverflow ? MAX_VISIBLE_TAGS - 1 : tags.length;
  const visibleTags = tags.slice(0, visibleCount);
  const overflowTags = tags.slice(visibleCount);
  const overflowCount = overflowTags.length;

  return (
    <div className={`flex justify-end gap-1 ${className}`}>
      {visibleTags.map((tag) => (
        <Tag
          className="max-w-28 justify-start"
          color={tag.color}
          key={tag.id}
          name={tag.name}
        />
      ))}

      {overflowCount > 0 && (
        <HoverCard>
          <HoverCardTrigger asChild>
            <Badge className={cn('cursor-default', BADGE_COLORS.gray)}>
              +{overflowCount} tags
            </Badge>
          </HoverCardTrigger>

          <HoverCardContent align="end" className="w-44 p-0 overflow-hidden">
            <div className="flex flex-col gap-1 p-1 max-h-72 overflow-y-auto">
              {overflowTags.map((tag) => (
                <div className="flex items-center gap-2 px-2 py-1.5" key={tag.id}>
                  <TagSwatch color={tag.color} />

                  <span className="text-xs font-medium text-foreground truncate">
                    {tag.name}
                  </span>
                </div>
              ))}
            </div>
          </HoverCardContent>
        </HoverCard>
      )}
    </div>
  );
};

TagList.propTypes = {
  className: PropTypes.string,
  tags: PropTypes.arrayOf(tagShape).isRequired,
};

export default TagList;
